<template>
	<div
		:class="vDropzoneClass" class="v-dropzone" @dragenter.prevent="setActive" @dragover.prevent="setActive"
		@dragleave.prevent="setInactive" @drop.prevent="onDrop">
		<!-- share state with the scoped slot -->
		<slot :dropZoneActive="active"></slot>
	</div>
</template>
<script>
export default {
	data() {
		return {
			active: false,
		};
	},

	computed: {
		vDropzoneClass() {
			return {
				"v-dropzone--active": this.active,
			};
		},
	},

	methods: {
		setActive() {
			this.active = true;
			this.$emit("dropzoneActive");
		},
		setInactive() {
			this.active = false;
			this.$emit("dropzoneInactive");
		},
		onDrop(e) {
			this.setInactive();
			this.$emit("files-dropped", [...e.dataTransfer.files]);
		},
		preventDefault(event) {
			event.preventDefault();
		},
	},

	mounted() {
		["dragenter", "dragover", "dragleave", "drop"].forEach(event => {
			document.body.addEventListener(event, this.preventDefault);
		});
	},

	destroyed() {
		["dragenter", "dragover", "dragleave", "drop"].forEach(event => {
			document.body.removeEventListener(event, this.preventDefault);
		});
	},
};
</script>
<style>
.v-dropzone {
	width: 100%;
	height: 100%;
	border: 1px solid red;
}

.v-dropzone--active {
	border: 1px solid green;
}
</style>
